var _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChildren(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M293.616,62.433c-13.014,-6.369 -41.309,65.951 -73.331,69.718c-32.025,3.768 -57.945,-1.814 -60.833,4.28c-2.887,6.087 -4.227,6.96 15.32,7.534c19.551,0.581 29.399,4.452 23.143,18.84c-6.245,14.395 -26.082,72.777 -26.082,72.777c0,0 -0.127,5.049 6.992,4.211c7.115,-0.835 18.826,-54.677 42.77,-59.651c23.947,-4.963 31.007,24.388 35.527,26.014c4.517,1.626 14.399,-0.262 7.291,-11.646c-7.109,-11.384 -20.449,-45.024 -15.581,-52.789c4.853,-7.755 46.877,-61.565 46.877,-61.565c0,-0 10.927,-11.35 -2.093,-17.723Z",
    style: {
      fillRule: "nonzero"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 209.795,
    cy: 87.907,
    r: 27.794
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3.339,117.897c9.669,-10.8 63.067,45.582 94.164,37.033c31.097,-8.548 53.013,-23.459 57.99,-18.905c4.956,4.555 6.527,4.867 -11.371,12.749c-17.898,7.878 -25.559,15.172 -14.361,26.147c11.196,10.989 51.521,57.647 51.521,57.647c0,-0 2.011,4.633 -4.901,6.524c-6.909,1.9 -37.996,-43.599 -62.056,-39.192c-24.072,4.379 -19.569,34.242 -23.15,37.445c-3.582,3.214 -13.44,5.187 -11.13,-8.036c2.31,-13.23 2.024,-49.414 -5.393,-54.78c-7.421,-5.358 -66.584,-39.425 -66.584,-39.425c0,0 -14.395,-6.41 -4.729,-17.207Z",
    style: {
      fillRule: "nonzero"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.67,
    cy: 122.427,
    r: 27.794
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildren);
export default __webpack_public_path__ + "static/media/children.bf1a47b8.svg";
export { ForwardRef as ReactComponent };